export default "__VITE_ASSET__ac065c1f__"